import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import "./AccountDashboard.scss";

import flowersTabIcon from "../../images/account/flowers-tab-icon.png";
import ordersIcon from "../../images/account/orders-icon.png";
import balanceIcon from "../../images/account/balance-icon.png";
import settingsIcon from "../../images/account/settings-icon.png";

const AccountDashboard = (props) => {
  const { t } = useTranslation();

  if (!props.isAuth) return null;

  return (
    <section className="account-dashboard">
      <div className="account-dashboard__container">
        <div className="account-dashboard__hello">
          <h1>{t("account.hello", { name: props.authUsername || t("account.defaultName") })}</h1>
          <p>{t("account.subtitle")}</p>
        </div>

        <nav className="account-dashboard__tabs">
          <NavLink to="/shop" activeClassName="active">
            <img src={flowersTabIcon} alt="" />
            {t("nav.shop")}
          </NavLink>

          <NavLink to="/orders" activeClassName="active">
            <img src={ordersIcon} alt="" />
            {t("nav.orders")}
          </NavLink>

          <NavLink to="/balance" activeClassName="active">
            <img src={balanceIcon} alt="" />
            {t("nav.balance")}
          </NavLink>

          <NavLink to="/settings" activeClassName="active">
            <img src={settingsIcon} alt="" />
            {t("nav.settings")}
          </NavLink>
        </nav>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  isAuth: !!state.auth.authUsername,
  authUsername: state.auth.authUsername,
});

export default connect(mapStateToProps)(AccountDashboard);